var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2HContractToHire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5C19.4467 4.5 21.8334 6.88667 21.8334 9.83333C21.8334 12.78 19.4467 15.1667 16.5 15.1667C13.5534 15.1667 11.1667 12.78 11.1667 9.83333C11.1667 6.88667 13.5534 4.5 16.5 4.5ZM21.8334 18.5533C21.8334 19.9667 21.46 23.26 18.9134 26.94L17.8334 20.5L19.0867 17.9933C18.26 17.9 17.3934 17.8333 16.5 17.8333C15.6067 17.8333 14.74 17.9 13.9134 17.9933L15.1667 20.5L14.0867 26.94C11.54 23.26 11.1667 19.9667 11.1667 18.5533C7.98004 19.4867 5.83337 21.1667 5.83337 23.1667V28.5H27.1667V23.1667C27.1667 21.1667 25.0334 19.4867 21.8334 18.5533Z",
    fill: "#3B54A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2HContractToHire);
export default __webpack_public_path__ + "static/media/C2H(Contract_to_Hire).a1a5d3567035ec3940ce1b35c6b34b11.svg";
export { ForwardRef as ReactComponent };